import { markRaw } from 'vue'
import RolesService from 'src/services/roles'
import { useUsersStore, useLocationsStore } from 'src/stores/index.js'

export default {
  checkRolesHierarchy () {
    const usersStore = useUsersStore()
    if (usersStore.currentIsOrganizationAdmin) {
      if (usersStore.current.organization.id) this.fetchRolesByOrganization()
    } else if (usersStore.currentIsSupervisor || usersStore.currentIsAdmin) {
      this.fetchNodesByFranchise({ ids: usersStore.userHierarchies.toString() })
    } else {
      this.fetchNodesByFranchise({ ids: usersStore.userHierarchies.toString() })
    }
  },
  fetchByUser (payload = {}) {
    this.status = 'loading'
    const usersStore = useUsersStore()
    if (!payload.organization_id) payload.organization_id = usersStore.current.organization.id

    const promise = RolesService.getRolesByUser(payload)
    promise.then(data => {
      this.roles = markRaw(data.data)
      this.status = 'success'
    })
      .catch(() => {
        this.status = 'error'
      })

    return promise
  },
  fetchByLocationHierarchy (locations) {
    this.status = 'loading'
    const usersStore = useUsersStore()
    const locationsStore = useLocationsStore()
    if (usersStore.currentIsOrganizationAdmin) {
      const franchises = locations
        .flatMap(loc => locationsStore.keyedById[loc]?.franchise_ids || [])
        .filter((id, index, self) => index === self.findIndex(o => o === id))
      const roles = this.rolesByFranchises.filter(role => {
        const roleFranchiseIds = Array.isArray(role.franchise_role_ids) ? role.franchise_role_ids : []
        return roleFranchiseIds.some(fran => franchises.includes(fran))
      })

      this.roles = markRaw(roles)
    } else {
      const currentRoles = locations.flatMap(location => {
        return usersStore.getRolesWithHierarchy.filter(loc => loc.location_id === location)
          .flatMap(loc => {
            return this.getUniqueRolesByHierarchy.filter(role => role.id === loc.id)
          })
          .flatMap(role => role.subRoles)
      })
        .reduce((uniqueRole, role) => {
          if (!uniqueRole.some(r => r.id === role.id)) uniqueRole.push(role)
          return uniqueRole
        }, [])

      if (usersStore.currentIsSupervisor || usersStore.currentIsAdmin) {
        const tops = [...usersStore.userFranchisesAdmin, ...usersStore.userFranchisesSupervisor]
        const roles = tops.filter(role => locations.some(loc => {
          const ids = locationsStore.keyedById[loc]?.franchise_ids
          return Array.isArray(ids) && ids.includes(role)
        }))

        if (roles.length > 0) {
          const topRoles = this.getAllRoles.filter(role => {
            const roleFranchiseIds = Array.isArray(role.franchise_role_ids) ? role.franchise_role_ids : []
            return roleFranchiseIds.some(id => roles.includes(id))
          })

          this.roles = markRaw([...topRoles, ...currentRoles])
        } else this.roles = markRaw(currentRoles)
      } else this.roles = markRaw(currentRoles)
    }

    this.status = 'success'
  },
  remove (roleId) {
    this.roles = markRaw(this.roles.filter(role => role.id !== roleId))
    this.status = 'success'
  },
  createNode (payload) {
    return RolesService.createNewNode(payload)
  },
  fetchNodes (payload) {
    const promise = RolesService.getNodes(payload)

    promise.then(response => {
      this.nodes = markRaw(response)
    })

    return promise
  },
  fetchNodesByFranchise (payload) {
    return RolesService.getNodesByFranchise(payload)
      .then(response => {
        this.nodes = markRaw(response)
      })
  },
  removeNode (payload) {
    return RolesService.removeNode(payload)
  },
  editNode (payload) {
    const promise = RolesService.editNode(payload)

    return promise
  },
  createRole (payload) {
    const promise = RolesService.createRole(payload)

    promise.then(data => {
      this.message = data
    })

    return promise
  },
  updateRole (payload) {
    const promise = RolesService.updateRole(payload)

    promise.then(data => {
      this.message = data
    })

    return promise
  },
  fetchRolesByFranchise (payload) {
    const promise = RolesService.roleByFranchise(payload)

    promise.then(data => {
      this.rolesByFranchises = markRaw(data)
    })

    return promise
  },
  fetchRolesByOrganization () {
    this.rolesByFranchises = markRaw([])

    const usersStore = useUsersStore()
    const promise = RolesService.roleByOrganization({ id: usersStore.current.organization.id })

    promise.then(data => {
      this.rolesByFranchises = data[0] != null ? markRaw(data[0]) : null
      this.nodes = markRaw(data[1])
    })

    return promise
  },
  resetRoles (payload) {
    this.rolesByFranchises = payload != null ? markRaw(payload) : null
  },
  setTopRoles (payload) {
    this.currentTopRoles = payload
  },
  fetchRolesHierarchy () {
    const promise = RolesService.fetchRolesHierarchy()

    promise.then(data => {
      this.hierarchyRoles = data.data
    }).catch(error => {
      console.error('Error al obtener la jerarquía de roles:', error)
      })
    return promise
  }
}
